import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {
  Router
} from '@angular/router';
import { ToastController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public toastController: ToastController
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('TOKEN');
    if (!request.headers.has('Content-Type')) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json'
        }
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          console.log('token.interceptor.ts - intercept() - map() - event ::', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        if (error.status === 401 || error.status === 402 || error.status === 400 || error.status === 403 || error.status === 500 || error.status === 503) {
          if (
            error.error.statusCode === 400 ||
            error.error.statusCode === 402 ||
            error.error.statusCode === 503 ||
            error.error.statusCode === 500 ||
            error.status === 400 ||
            error.status === 402 ||
            error.status === 503 ||
            error.status === 500
          ) {
            console.log("error");
            console.log(  );

            //mensaje traduccion
            let tit_error = this.translate.store.translations[this.translate.store.currentLang]["WE ARE SORRY!"],
              //subtit_error = this.translate.store.translations[this.translate.store.currentLang]['FAILED SIGNUP'], 
              msm_error = "",
              anexmsm_error = ' ' + this.translate.store.translations[this.translate.store.currentLang]["YOU WANT TO TRY AGAIN?"];

            if (!error.status) {
              tit_error = this.translate.store.translations[this.translate.store.currentLang]["NO CONNECTION"];
              msm_error = this.translate.store.translations[this.translate.store.currentLang]["CHECK YOUR INTERNET CONNECTION, IF IT LEAVES, THE OPERATION IS CANCELED"];
            }

            if (error.error && error.error.details && error.error.details.codes) {
              for (var i = 0; i < error.error.details.codes.length; ++i) {
                msm_error = msm_error + error.error.details.codes[i][0];
              }
              msm_error = this.translate.instant(msm_error) ? this.translate.instant(msm_error) : msm_error;
            } else if (error.error && error.error.errors) {
              msm_error = error.error.errors[0].message
            } else if (error.error && error.error.error_description) {
              msm_error = error.error.error_description
            } else if (error.error && error?.error?.msg) {
              console.log("error.error && error?.error?.msg")
              let msg = error?.error?.msg

              if(typeof msg === 'string'){
                msg = msg.toUpperCase()
              }
              msg = this.translate.instant("B_ERRORS.ADDRESS_NOT_FOUNT") ? 
              this.translate.instant("B_ERRORS.ADDRESS_NOT_FOUNT") : 
                msg

              console.log(msg)
              
              msm_error = msg ?  msg : error.error;
            } else if (error.error && error?.error) {
              console.log("error.error && error?.error")
              let msg = error?.error
              if(typeof msg === 'string'){
                msg = msg.toUpperCase()
              }
              msg = this.translate.instant(msg)
              
              msm_error = msg ?  msg : error.error;
            } 

            this.presentAlert(tit_error, msm_error + anexmsm_error);
          } else {
            this.router.navigate(['login']);
          }
        }else if(error.status === 0){
          /* let tit_error = this.translate.store.translations[this.translate.store.currentLang]["WE ARE SORRY!"],
          msm_error = "",
          anexmsm_error = ' ' + this.translate.store.translations[this.translate.store.currentLang]["CHECK YOUR INTERNET CONECTION"];
          this.presentAlert(tit_error, msm_error + anexmsm_error); */
        }else if(error.status === 404){
          let tit_error = this.translate.store.translations[this.translate.store.currentLang]["FAILED OPERATION"],
          msm_error = "B_ERRORS."+error.error.msg;
          let anexmsm_error = this.translate.instant(msm_error);
          anexmsm_error = anexmsm_error ? anexmsm_error : this.translate.instant("ERROR INTERNAL");
          this.presentAlert(tit_error, anexmsm_error);
        }

        return throwError(error);
    }));
  }

  //toast de mesaje alert

  async presentToast(msg) {

    const toast = await this.toastController.create({
      message: msg,
      duration: 3000
    });
    toast.present();
  }

  //todo salio bien

  async presentAlert(header, message) {
    const alert = await this.alertCtrl.create({
      header: header,
      message: message,
      buttons: [{
        text: 'OK',
        handler: () => {
          // this.router.navigate(['login']);
        }
      }]
    });

    await alert.present();
  }

}